<template>
    <div class="modal-mask" @touchmove.stop.prevent></div>
</template>

<script>
export default {
  name: 'ModalMask'
}
</script>

<style scoped lang="less">
  .modal-mask {
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,0.8);
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    overscroll-behavior: contain;
  }
</style>
